module.exports = __webpack_public_path__ + "static/img/zui.f9ac0ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/zui.png
// module id = Bqbs
// module chunks = 3